import { useState, useEffect } from "react";
import { G } from "../../constants/theme";
import { NAV_ITEMS } from "../../constants/navigation";
import { BtnG } from "../ui/Buttons";

export default function Navbar({ page, onNavigate }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  const go = (id) => {
    onNavigate(id);
    setMenuOpen(false);
  };

  return (
    <>
      <nav
        style={{
          position: "sticky",
          top: 0,
          zIndex: 200,
          background: "rgba(8,10,8,0.97)",
          borderBottom: `1px solid ${G.border}`,
          backdropFilter: "blur(14px)",
          height: 60,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 20px",
        }}
      >
        {/* Logo */}
        <div style={{ cursor: "pointer" }} onClick={() => go("home")}>
          <div
            style={{
              fontFamily: "'Bebas Neue', sans-serif",
              fontSize: 20,
              color: G.white,
              letterSpacing: 3,
              lineHeight: 1,
            }}
          >
            MEBC
          </div>
          <div
            style={{
              fontFamily: "monospace",
              fontSize: 7,
              color: G.green,
              letterSpacing: 2,
              textTransform: "uppercase",
            }}
          >
            Middle East Black Carbon
          </div>
        </div>

        {/* Desktop links */}
        {!isMobile && (
          <ul style={{ display: "flex", gap: 24, listStyle: "none" }}>
            {NAV_ITEMS.map((n) => (
              <li key={n.id}>
                <button
                  onClick={() => go(n.id)}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    fontFamily: "monospace",
                    fontSize: 11,
                    letterSpacing: 1.5,
                    textTransform: "uppercase",
                    color: page === n.id ? G.green : G.muted,
                    padding: "4px 0",
                    borderBottom: page === n.id ? `1px solid ${G.green}` : "1px solid transparent",
                    transition: "all .2s",
                  }}
                >
                  {n.label}
                </button>
              </li>
            ))}
          </ul>
        )}

        {/* Desktop CTA */}
        {!isMobile && <BtnG onClick={() => go("contact")}>Request Info</BtnG>}

        {/* Mobile hamburger */}
        {isMobile && (
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            style={{
              background: "none",
              border: `1px solid ${G.border}`,
              cursor: "pointer",
              padding: "8px 10px",
              display: "flex",
              flexDirection: "column",
              gap: 5,
            }}
          >
            {[0, 1, 2].map((i) => (
              <span
                key={i}
                style={{
                  display: "block",
                  width: 22,
                  height: 2,
                  background: menuOpen ? G.green : G.muted,
                }}
              />
            ))}
          </button>
        )}
      </nav>

      {/* Mobile dropdown */}
      {isMobile && menuOpen && (
        <div
          style={{
            position: "fixed",
            top: 60,
            left: 0,
            right: 0,
            zIndex: 199,
            background: "rgba(8,10,8,0.98)",
            borderBottom: `1px solid ${G.border}`,
            padding: "16px 0",
          }}
        >
          {NAV_ITEMS.map((n) => (
            <button
              key={n.id}
              onClick={() => go(n.id)}
              style={{
                display: "block",
                width: "100%",
                background: "none",
                border: "none",
                cursor: "pointer",
                fontFamily: "monospace",
                fontSize: 13,
                letterSpacing: 2,
                textTransform: "uppercase",
                color: page === n.id ? G.green : G.muted,
                padding: "14px 24px",
                textAlign: "left",
                borderBottom: `1px solid ${G.border}`,
              }}
            >
              {n.label}
            </button>
          ))}
          <div style={{ padding: "16px 24px" }}>
            <BtnG onClick={() => go("contact")}>Request Info</BtnG>
          </div>
        </div>
      )}
    </>
  );
}
